import React, { useState, useEffect } from 'react'

//Bibliotecas
import styled from 'styled-components';

//Servicios
import ProgresoService from '../../services/ProgresoService';

//Imágenes
import { Circle, Star, Triangle, MoreVertical } from 'react-feather';


function AsideNavigation({ data, pageIndex, pageNavigate, progreso, setProgreso, _id, guardarProgreso }) {

  //Cargar datos de progreso
  useEffect(() => {
    ProgresoService.obtenerProgreso().then((res) => {
      setProgreso(res[0].grupos[0].progreso[_id]);
    })
  }, [])

  const menu = (page, index) => {
    if (page[0]?.tipo == "titulo") {
      if (page[0]?.contenido?.data?.includes("Caso práctico")) {
        return (<>
          <div className='indicators'>
            <Triangle className={progreso[index] == true ? 'success' : undefined}></Triangle>
            {index != data.length - 1 &&
              <MoreVertical></MoreVertical>
            }
          </div>
          <span className={pageIndex == index ? "active" : "not-active"}>{page[0].contenido.data}</span>
        </>)
      } else {
        return (<>
          <div className='indicators'>
            <Circle className={progreso[index] == true ? 'success' : undefined}></Circle>
            {index != data.length - 1 &&
              <MoreVertical></MoreVertical>
            }
          </div>
          <span className={pageIndex == index ? "active" : "not-active"}>{page[0].contenido.data}</span>
        </>)
      }
    } else if (page[0]?.tipo != "titulo") {
      return(
      <>
        <div className='indicators'>
          <Star className={progreso[index]?.success == true ? 'success' : undefined}></Star>
          {index != data.length - 1 &&
            <MoreVertical></MoreVertical>
          }
        </div>
        <span className={pageIndex == index ? "active" : "not-active"}>{"Actividad"}</span>
      </>)
    }
  }


  return (
    <Wrapper>
      <div className="fixed-wrapper">
        <div className="fixed">
          <h3>Contenido temático</h3>
          {data.map((page, index) =>
            <Element key={index} onClick={() => { pageNavigate(index); guardarProgreso(pageIndex) }}>
              {menu(page,index)}
            </Element>
          )}
        </div>
      </div>
    </Wrapper>
  )
}

export default AsideNavigation


const Wrapper = styled.div`
    width:25%;
    max-height:100%;
    background-color: var(--color-gris-claro);
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    border-left:1px solid var(--color-gris-oscuro);
    position:relative;
    
    h3{
      margin-bottom:24px;
      font-weight:900;
    }

    .fixed-wrapper {
        position: absolute;
        top: 24px;
        display:flex;
        justify-content:center;  
    }

    .fixed {
        width: auto;
        position: fixed;
        background-color: var(--color-gris-claro);
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        margin:0 32px 0 40px ;
    }
   
`;

const Element = styled.div`
    width:100%;
    padding: 0 16px 0px 16px ;
    display:flex;
    flex-direction:row;
    justify-content:left;
    align-items:top;
    text-align:left;
    cursor: pointer;
    z-index:1;
    
    .active{
      font-weight:700;
      
    }

    svg{
      padding-right:16px;
      width:10%;
      width: 24px;
      height: 24px;
      stroke: none;
      fill: #C7D3DC;
    }

    svg:nth-child(2){
      stroke: #94A2AB;
      height:18px
    }

    span{
      transition:all 0.5s;
      width:100%;
      text-align:left;
    } 

    .indicators{
      min-width: 64px;
    }

    .success{
      fill: #7FFFAA;
    }
`;
